// src/data/cars.js
// Import each image from src/assets/cars/*
import rangerVelar from "../assets/cars/Ranger rover velar 2025.png";
import patrol2024 from "../assets/cars/nissan patrol 2024.png";
import landCruiser2024 from "../assets/cars/Toyota Land Cruiser 2024.png";
import challenger2023 from "../assets/cars/Dodge Challenger 2023.png";
import fortuner from "../assets/cars/Toyota Fortuner.png";
import rush2023 from "../assets/cars/Toyota Rush 2023.png";
import creta2024 from "../assets/cars/Hyundai Creta 2024.png";
import seltos2023 from "../assets/cars/Kia Seltos 2023.png";
import sportage2022 from "../assets/cars/Kia sportage 2022.png";
import mazda62023 from "../assets/cars/Mazda 6 2023.png";
import accent2023 from "../assets/cars/Hyundai Accent 2023.png";
import sunny2024 from "../assets/cars/Nissan Sunny 2024.png";
import picanto2023 from "../assets/cars/Kia Picanto 2023.png";
import i102023 from "../assets/cars/Hyundai i10 2023.png";

const Cars = [
 
  { name: "Nissan Patrol", seats: 7, doors: 4, transmission: "auto", image: patrol2024 },
  { name: "Toyota Fortuner", seats: 7, doors: 4, transmission: "auto", image: fortuner },
  { name: "Toyota Rush", seats: 7, doors: 4, transmission: "auto", image: rush2023 },
  { name: "Hyundai Creta", seats: 5, doors: 4, transmission: "auto", image: creta2024 },
  { name: "Kia Seltos", seats: 5, doors: 4, transmission: "auto", image: seltos2023 },
  { name: "Mazda 6", seats: 5, doors: 4, transmission: "auto", image: mazda62023 },
  { name: "Hyundai Accent", seats: 5, doors: 4, transmission: "auto", image: accent2023 },
  { name: "Kia Picanto", seats: 5, doors: 4, transmission: "auto", image: picanto2023 },
  { name: "Kia Sportage", seats: 5, doors: 4, transmission: "auto", image: sportage2022 },
  { name: "Hyundai i10", seats: 5, doors: 4, transmission: "auto", image: i102023 },
  { name: "Dodge Challenger", seats: 5, doors: 2, transmission: "auto", image: challenger2023 },
  { name: "Ranger Rover Velar", seats: 5, doors: 4, transmission: "auto", image: rangerVelar },
  { name: "Toyota Land Cruiser", seats: 7, doors: 4, transmission: "auto", image: landCruiser2024 },
  { name: "Nissan Sunny (Indian Model)", seats: 5, doors: 4, transmission: "auto", image: sunny2024 },
];

export default Cars;
